export const dmFinaleAusschreibung2026 = {
	"id": "dm-finale-ausschreibung-2026",
	"title": "Ausschreibung: Deutsche Meisterschaft im 15er-Rugby – Finale am 13. Juni 2026",
	"slug": "dm-finale-ausschreibung-rugby-2026",
	"publishedAt": "2025-10-30T10:00:00Z",
	"author": "Rugby Deutschland",
	"language": "de",
	"readTime": "2 min",
	"tags": ["Rugby", "Deutsche Meisterschaft", "Bundesliga", "Finale", "Ausschreibung"],
	"excerpt": "Rugby Deutschland schreibt offiziell die Ausrichtung des DM-Finales im 15er-Rugby aus. Bewerbungen sind bis zum 13. Dezember 2025 möglich.",
	"img": "/images/dm-finale-ausschreibung-rugby-2026.jpg",
	"blocks": [
		{
			"type": "paragraph",
			"content": "Rugby Deutschland und der Bundesligaausschuss (RBA) haben offiziell die Ausrichtung des Endspiels um die Deutsche Meisterschaft im 15er-Rugby der Männer ausgeschrieben. Das offizielle Finale der aktuellen Bundesliga-Saison soll am 13. Juni 2026 ausgetragen werden."
		},
		{
			"type": "heading",
			"level": 2,
			"content": "Bewerbungsfrist bis 13. Dezember 2025"
		},
		{
			"type": "paragraph",
			"content": "Vereine und Austragungsorte, die Interesse an der Ausrichtung des prestigeträchtigen Finals haben, können ihre Bewerbung bis zum 13. Dezember 2025 einreichen. Die Bewerbungen sind per E-Mail an office@rugbydeutschland.org zu richten."
		},
		{
			"type": "paragraph",
			"content": "Die offizielle und vollständige Ausschreibung zur Durchführung des DM-Endspiels 2025 am 13. Juni 2026 enthält alle relevanten Informationen zu den Anforderungen und Rahmenbedingungen für potenzielle Ausrichter."
		},
		{
			"type": "heading",
			"level": 2,
			"content": "Ansprechpartner für Rückfragen"
		},
		{
			"type": "paragraph",
			"content": "Bei Fragen zur Ausschreibung stehen Interessenten zwei Ansprechpartner zur Verfügung: Branimir Niko Colic ist per E-Mail unter rba.Vorsitz@rugbydeutschland.org oder telefonisch unter +4917634902250 erreichbar. Alternativ steht auch Florian Hartmann unter fhartmann@rugbydeutschland.org für Auskünfte bereit."
		},
		{
			"type": "callout",
			"variant": "info",
			"title": "Wichtige Termine im Überblick",
			"content": "Bewerbungsfrist: 13. Dezember 2025 | Finale: 13. Juni 2026 | Kontakt: office@rugbydeutschland.org"
		},
		{
			"type": "paragraph",
			"content": "Das DM-Finale stellt den Höhepunkt der Bundesliga-Saison dar und bietet den ausrichtenden Vereinen die Gelegenheit, sich als Gastgeber des wichtigsten Spiels im deutschen Rugby zu präsentieren."
		},
		{
			"type": "heading",
			"level": 2,
			"content": "Weitere Informationen"
		},
		{
			"type": "paragraph",
			"content": "Die vollständige Ausschreibung zur Ausrichtung des DM-Finales 2026 ist unter folgendem Link verfügbar:"
		},
		{
			"type": "list",
			"items": [
				{ "content": "Ausschreibung DM-Finale 2026", "url": "https://clubee-storage-prod.s3.eu-central-1.amazonaws.com/4253/files/application/6901d39eb97ff.pdf" }
			]
		}
	]
}
